"use client";

import createIcon from './util/createIcon';
export default createIcon('M10.74 10.75L12 8L13.25 10.75L16 12L13.25 13.26L12 16L10.74 13.26L8 12L10.74 10.75Z', 'StarFourPointsSmall');